import _defineProperty from "/var/lib/jenkins/workspace/vansterpartiet.se/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * @typedef {import('hast').Root} Root
 *
 * @typedef Options
 *   Configuration.
 * @property {boolean} [fragment=true]
 *   Specify whether to parse a fragment, instead of a complete document.
 *   In document mode, unopened `html`, `head`, and `body` elements are opened
 *   in just the right places.
 */
import { fromDom } from 'hast-util-from-dom';
/** @type {import('unified').Plugin<[Options?] | Array<void>, string, Root>} */

export default function parse(options) {
  var settings =
  /** @type {Options} */
  this.data('settings');

  var _options$settings = _objectSpread(_objectSpread({}, options), settings),
      fragment = _options$settings.fragment;

  Object.assign(this, {
    Parser: parser
  });
  /** @type {import('unified').ParserFunction<Root>} */

  function parser(doc) {
    var create = fragment === null || fragment === undefined || fragment ? createFragment : createDocument;
    return (
      /** @type {Root} */
      fromDom(create(doc))
    );
  }
}
var DOCUMENT_FRAGMENT_NODE = 11;
/**
 * @param {string} htmlString
 * @returns {DocumentFragment}
 */

function createFragment(htmlString) {
  var doc = createDocument('<!doctype html><body>' + htmlString);
  /**
   * Pretend as a DocumentFragment node,
   * @see https://github.com/rehypejs/rehype-dom/pull/19 for more details
   */

  return (
    /** @type {DocumentFragment} */
    {
      nodeType: DOCUMENT_FRAGMENT_NODE,
      childNodes: doc.body.childNodes
    }
  );
}
/**
 * @param {string} htmlString
 * @returns {Document}
 */


function createDocument(htmlString) {
  return new DOMParser().parseFromString(htmlString, 'text/html');
}